// import deepEqual from "deep-equal";
import { GeoPoint, deleteField } from 'firebase/firestore'
import * as jsonPatch from 'fast-json-patch'
import * as _ from "lodash";

const numberInPathRegex = /[0-9]+/g
const extractPathRegex = /[A-Za-z0-9äÄöÖüÜß]+/g

const isArrayIndicator = (element: string) => numberInPathRegex.test(element)

export const isArray = function (x: any): boolean {
    return Object.prototype.toString.call(x) === '[object Array]';
  }
export const isObject = function (x: any): boolean {
    return Object.prototype.toString.call(x) === '[object Object]';
}
const isValue = function (x: any): boolean {
    return !isObject(x) && !isArray(x);
}

export const isDate = function (x: any): boolean {
    return Object.prototype.toString.call(x) === '[object Date]';
}

export const isFirebaseTimestamp = function (x: any): boolean {
    if (!x) return false
    return (Object.keys(x).includes('seconds') && Object.keys(x).includes('nanoseconds')) || (Object.keys(x).includes('_seconds') && Object.keys(x).includes('_nanoseconds'));
}

export const getTimeFirebaseTimestamp = function (element:any): any{
    let dateValue
    dateValue = element

    if(element){
      if(element['_nanoseconds'] || element['_seconds']){
        const NS_TO_MS_MULTIPLIER = 1/1000000
        const SEC_TO_MS_MULTIPLIER = 1000
        const timestampInMilliseconds = element['_seconds'] * SEC_TO_MS_MULTIPLIER + element['_nanoseconds'] * NS_TO_MS_MULTIPLIER
        const date = new Date(timestampInMilliseconds)
        element= date
        dateValue = date.toUTCString()
      }

      if(element['nanoseconds'] || element['seconds']){
        const NS_TO_MS_MULTIPLIER = 1/1000000
        const SEC_TO_MS_MULTIPLIER = 1000
        const timestampInMilliseconds = element['seconds'] * SEC_TO_MS_MULTIPLIER + element['nanoseconds'] * NS_TO_MS_MULTIPLIER
        const date = new Date(timestampInMilliseconds)
        element= date
        dateValue = date.toUTCString()
      }

      try{
        const newdate = new Date(element)
        if(newdate)
            dateValue = newdate.getTime()
      }catch(errro){}
    }
   return dateValue
  }

export const isFirebaseGeoPoint = function (x: any): boolean {
    if (!x) return false
    else return (x.latitude || x.longitude)
}

export const diffObject = (oldObj: any, newObj: any, result: any): any|undefined => {
    if (!newObj) newObj = {};
    if (oldObj == undefined && newObj) {
        if (isObject(newObj)) {
            for (let [k, v] of Object.entries(newObj)) {
                result[k] = {oldValue: undefined, newValue: v}
            }
            return result
        }
    } 
    if (oldObj == undefined) return undefined
    const oldKeys = Object.keys(oldObj)
    for (let [key, value] of Object.entries(newObj)) {
        if (oldKeys.includes(key) && !isObject(value) && !isDate(value) && !isFirebaseTimestamp(value)) {
            // check euality.. 
            if(isArray(oldObj[key])){ //*******added on 12.05 to check each value on array for checking differences*/
                const oldKey = oldObj[key]
                const newKey = value as any
                if(oldKey && newKey){
                    const maxLength = Math.max(oldKey.length, newKey.length);
                    const arrayDiff = []
    
                    for (let i = 0; i < maxLength; i++) {
                        // ---- check obj inside array)
                        if (isObject(newKey[i])) {
                            const map = diffObject(oldObj[key], newKey[i], {})
                            // console.log('map',map)
                            if (map) {
                                for (let [k, v] of Object.entries(map)) {
                                    let r = v as any
                                    const oldValue = oldKey[i] ? oldKey[i][k] : undefined
                                    // if( oldValue != r.newValue )//prevent undefined oldValue, newValue
                                    // result[`${key}.${i}.${k}`] = v
                                    if(JSON.stringify(newKey[i]) !== JSON.stringify(oldKey[i]))
                                        arrayDiff.push({position: i, newValue: newKey[i], oldValue: oldKey[i]});
                                    // arrayDiff.push({position: i, newValue: r.newValue, oldValue: oldValue});
                            //         let val = v as any
                            //         if( !oldObj[key][i] || !oldObj[key][i][k] ){
                            //             // result[`${key}.${i}.${k}`] = {oldValue: undefined, newValue: val?.newValue}
                            //             arrayDiff.push({
                            //                 position: i,
                            //                 newValue: newKey[i],
                            //                 oldValue: oldKey[i]
                            //             });
                            //         }
                            //         if( oldObj[key] && oldObj[key][i] && oldObj[key][i][k] !== val.newValue){
                            //             // result[`${key}.${i}.${k}`] = {oldValue: oldObj[key][i][k] ? oldObj[key][i][k] : undefined, newValue: val?.newValue}
                            //             arrayDiff.push({
                            //                 position: i,
                            //                 newValue: newKey[i],
                            //                 oldValue: oldKey[i]
                            //             });
                            //         }
                                }
                            }
                            // console.log('result',result)
                        } else {
                            if (oldKey[i] !== newKey[i]) {
                                arrayDiff.push({
                                    position: i,
                                    newValue: newKey[i],
                                    oldValue: oldKey[i]
                                });
                            }
                        }
                    }
                    // console.log('arrayDiff-----', arrayDiff)
    
                    if(Object.keys(arrayDiff)?.length!=0)
                    result[key] = {oldValue: oldObj[key], newValue: value}
                }
            }else{
                if (oldObj[key] == value) continue
                else {
                    result[key] = {oldValue: oldObj[key], newValue: value}
                }   
            }
            
        } else if (isDate(value)) {
            const oldDate: Date = oldObj[key]
            const newDate: Date = value as any
            if (newDate?.getTime() ==  (isFirebaseTimestamp(oldDate) ? getTimeFirebaseTimestamp(oldDate) : oldDate?.getTime())) continue
            else {
                result[key] = {oldValue: oldDate, newValue: newDate}
            }
        } else if(isFirebaseTimestamp(value)) {
            if ((value as any).seconds == (oldObj[key] as any).seconds) continue
            else {
                result[key] = {oldValue: oldObj[key], newValue: value}
            }
        } else if (isFirebaseGeoPoint(value)) {
            const oldLoc = oldObj[key] as GeoPoint|undefined
            const newLoc = value as GeoPoint
            if (oldLoc?.isEqual(newLoc)) continue
            else {
                result[key] = {oldValue: oldObj[key], newValue: value}
            }
        } else if (isObject(value)) {
            const map = diffObject(oldObj[key], value, {})
            if (map) {
                for (let [k, v] of Object.entries(map)) {
                    let r = v as any
                    if(r.oldValue!=undefined || r.newValue!=undefined)//prevent undefined oldValue, newValue
                    result[`${key}.${k}`] = v
                }
            }
        } else {
            if (value == null || value == undefined || key == "className") continue
            else if (isObject(value)) {
                const map = diffObject(undefined, value, {})
                if (map) {
                    for (let [k, v] of Object.entries(map)) {
                        result[`${key}.${k}`] = v
                    }
                }
            }
            else result[key] = {oldValue: undefined, newValue: value}
        }
    }

    for (const [key,value] of Object.entries(oldObj)) { // delete fields that exist in oldObj but not in newObj
        if (!Object.prototype.hasOwnProperty.call(newObj, key))
            result[key] = { oldValue: oldObj[key], newValue: undefined };
    }
    return result
}

export const diffObjectPrev = (oldObj: any, newObj: any, result: any): any|undefined => {
    if (!newObj) newObj = {};
    if (oldObj == undefined && newObj) {
        if (isObject(newObj)) {
            for (let [k, v] of Object.entries(newObj)) {
                result[k] = {oldValue: undefined, newValue: v}
            }
            return result
        }
    } 
    if (oldObj == undefined) return undefined
    const oldKeys = Object.keys(oldObj)
    for (let [key, value] of Object.entries(newObj)) {
        if (oldKeys.includes(key) && !isObject(value) && !isDate(value) && !isFirebaseTimestamp(value)) {
            // check euality.. 
            if(isArray(oldObj[key])){ //*******added on 12.05 to check each value on array for checking differences*/
                const oldKey = oldObj[key]
                const newKey = value as any
                const maxLength = Math.max(oldKey.length, newKey.length);
                const arrayDiff = []

                for (let i = 0; i < maxLength; i++) {
                    if (oldKey[i] !== newKey[i]) {
                        arrayDiff.push({
                            position: i,
                            newValue: newKey[i],
                            oldValue: oldKey[i]
                        });
                    }
                }

                if(Object.keys(arrayDiff)?.length!=0)
                result[key] = {oldValue: oldObj[key], newValue: value}
            }else{
                if (oldObj[key] == value) continue
                else {
                    result[key] = {oldValue: oldObj[key], newValue: value}
                }   
            }
            
        } else if (isDate(value)) {
            const oldDate: Date = oldObj[key]
            const newDate: Date = value as any
            if (newDate.getTime() == oldDate?.getTime()) continue
            else {
                result[key] = {oldValue: oldDate, newValue: newDate}
            }
        } else if(isFirebaseTimestamp(value)) {
            if ((value as any).seconds == (oldObj[key] as any).seconds) continue
            else {
                result[key] = {oldValue: oldObj[key], newValue: value}
            }
        } else if (isFirebaseGeoPoint(value)) {
            const oldLoc = oldObj[key] as GeoPoint|undefined
            const newLoc = value as GeoPoint
            if (oldLoc?.isEqual(newLoc)) continue
            else {
                result[key] = {oldValue: oldObj[key], newValue: value}
            }
        } else if (isObject(value)) {
            const map = diffObject(oldObj[key], value, {})
            if (map) {
                for (let [k, v] of Object.entries(map)) {
                    result[`${key}.${k}`] = v
                }
            }
        } else {
            if (value == null || value == undefined || key == "className") continue
            else if (isObject(value)) {
                const map = diffObject(undefined, value, {})
                if (map) {
                    for (let [k, v] of Object.entries(map)) {
                        result[`${key}.${k}`] = v
                    }
                }
            }
            else result[key] = {oldValue: undefined, newValue: value}
        }
    }

    for (const [key,value] of Object.entries(oldObj)) { // delete fields that exist in oldObj but not in newObj
        if (!Object.prototype.hasOwnProperty.call(newObj, key))
            result[key] = { oldValue: oldObj[key], newValue: undefined };
    }
    return result
}

export const buildCustomDiff = (oldObj: any, newObj: any): any => {
    const diff = jsonPatch.compare(oldObj, newObj, true)
    const result: any = {}
    if (diff.length == 0) return result
    for (let op of diff) {
        const pathParts = op.path.match(extractPathRegex)
        if (!pathParts) continue
        const containsArrayAtPathIndex = pathParts.findIndex(isArrayIndicator)
        let path: string|null = null
        let value: any = null
        if (containsArrayAtPathIndex == -1) {
            // does not contain array
            path = pathParts.join('.')
        } else {
            // contains array
            const shortPathParts = pathParts.slice(0, containsArrayAtPathIndex)
            path = shortPathParts.join('.')
        }
        if (path.includes("updateTimestamp") || path.includes("creationDate")) continue
        if (op.op == "test") value = _.get(oldObj, path)
        else value = _.get(newObj, path)
        if (!result[path]) result[path] = {oldValue: undefined, newValue: undefined}
        switch(op.op) {
            case "add": {
                result[path].newValue = value
                break
            }
            case "copy": {
                console.warn("No action defined for copy", op)
                // probably not needed?
                break
            }
            case "move": {
                console.warn("No action defined for move", op)
                break
            }
            case "remove": {
                // not needed newValue already undefined
                break
            }
            case "replace": {
                result[path].newValue = value
                break
            }
            case "test": {
                result[path].oldValue = value
                break
            }
        }
    }
    return result
}

export const updatesToFirestoreUpdates = (updates:any): any => {
    let map: any = {}
    for (let [key, value] of Object.entries(updates)) {
        const {newValue} = value as any
        map[key] = newValue ? newValue : deleteField()
    }
    // updates.forEach((value, key) => {
    //     const {newValue} = value
    //     map[key] = newValue ? newValue : firebase.default.firestore.FieldValue.delete()
    // })
    return map
}

export const removeUndefined = (obj: any): any => {
    // console.log(obj)
    for (var propName in obj) {
        if (isArray(obj[propName])) {
            let newArray = []
            for(let o of obj[propName]) {
                newArray.push(
                    removeUndefined(o)
                )
            }
            obj[propName] = newArray
        } else if (isObject(obj[propName])) {
            obj[propName] = removeUndefined(obj[propName])
        } else if (obj[propName] === undefined || obj[propName] === null) {
            delete obj[propName];
        }
    }
    // console.log(obj)
    return obj
}



export const removeNull = (obj: any): any => {
    // console.log(obj)
    for (var propName in obj) {
        if (isArray(obj[propName])) {
            let newArray = []
            for(let o of obj[propName]) {
                newArray.push(
                    removeNull(o)
                )
            }
            obj[propName] = newArray
        } else if (isObject(obj[propName])) {
            obj[propName] = removeNull(obj[propName])
        } else if (obj[propName] === null) {
            delete obj[propName];
        }
    }
    // console.log(obj)
    return obj
}


export const firestoreTimestampToDate = (timestamp: any): Date|undefined => {
    if (!timestamp) return undefined
    else if (timestamp._seconds) return new Date(timestamp._seconds * 1000)
    else return new Date(timestamp.seconds * 1000)
}

export function deepCopy(obj: any, replacerFn?: (key: string) => boolean): any {
    var copy: any;
    if (null == obj || "object" != typeof obj) return obj;
    // Handle Date
    if (isFirebaseGeoPoint(obj)) {
        // console.log("deep copy location coordinate")
        const copy = new GeoPoint(obj.latitude, obj.longitude)
        return copy
    }

    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                // replacerFn if exists should return true for values to be included, 
                // false for values to be skipped 
                if (replacerFn) {
                    if (replacerFn(attr)) {
                        copy[attr] = deepCopy(obj[attr])
                    } else {
                        continue
                    }
                } else copy[attr] = deepCopy(obj[attr])
            }
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}

const skipDeepCopy = Symbol('skipDeepCopy')

export const count = (arr: any, condition: any) => arr.reduce((acc: any, c: any) => condition(c) ? ++acc : acc, 0); 

export const byString = (o: any, s: string): any => {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (!o) {
        return null
      } else {
        if (k in o) {
          o = o[k];
        } else {
          return null;
        }
      }
    }
    return o;
  }

  export const convertDateTime = function(element:any){
    let dateValue
    dateValue = element
    
    if(element){
        if(element['_nanoseconds'] || element['_seconds']){
            const NS_TO_MS_MULTIPLIER = 1/1000000
            const SEC_TO_MS_MULTIPLIER = 1000
            const timestampInMilliseconds = element['_seconds'] * SEC_TO_MS_MULTIPLIER + element['_nanoseconds'] * NS_TO_MS_MULTIPLIER
            const date = new Date(timestampInMilliseconds)
            element= date
            dateValue = date.toLocaleDateString('de-DE',{year: 'numeric', month: '2-digit', day:'2-digit'})
            dateValue +=', '+ date.toLocaleTimeString('de-DE', { hour: "2-digit", minute: "2-digit" })    
        }
    
        if(element['nanoseconds'] || element['seconds']){
            const NS_TO_MS_MULTIPLIER = 1/1000000
            const SEC_TO_MS_MULTIPLIER = 1000
            const timestampInMilliseconds = element['seconds'] * SEC_TO_MS_MULTIPLIER + element['nanoseconds'] * NS_TO_MS_MULTIPLIER
            const date = new Date(timestampInMilliseconds)
            element= date
            dateValue = date.toLocaleDateString('de-DE',{year: 'numeric', month: '2-digit', day:'2-digit'})
            dateValue +=', '+ date.toLocaleTimeString('de-DE', { hour: "2-digit", minute: "2-digit" })
        }
    
        try{
          const newdate = new Date(element)
          if(newdate)
              dateValue = newdate.toLocaleDateString('de-DE',{year: 'numeric', month: '2-digit', day:'2-digit'})
              dateValue +=', '+ newdate.toLocaleTimeString('de-DE', { hour: "2-digit", minute: "2-digit" })
        }catch(errro){}
    }
    return dateValue
  }

  export const dataToObject = function(obj:any){
    const data: any = {};

    Object.entries(obj).forEach(([key, value]) => {
        if (!key.includes('.')) {
            data[key] = value;
            return;
        }

        const parts = key.split('.');
        let current = data;

        parts.forEach((part, index) => {
        if (index === parts.length - 1)
            current[part] = value;
        else {
            if (!current[part]) 
                current[part] = {};
            
            current = current[part];
        }
        });
    });

    return data;
  }

  export const generateId = function(length:any) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

export const preparePOTtoFirestore = function (poi: any) {
    const plain: any = {};
    for (const key of Object.keys(poi)) {
        if (['context', 'className'].includes(key)) continue;
        const val = (poi as any)[key];
        if (val !== undefined) plain[key] = val;
    }
    return plain
}